exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,300i,400,400i,600,600i,700,700i|Roboto+Condensed:300,400,700|Roboto:300,300i,400,400i,500,500i,700,700i&subset=latin-ext);", ""]);

// module
exports.push([module.id, "/* stylelint-disable */\n\n/* stylelint-disable */\n\n.hide-on-desktop {\n  display: none !important; }\n\n@media (max-width: 767px) {\n  .hide-on-mobile {\n    display: none !important; }\n  .hide-on-desktop {\n    display: block !important; } }\n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  /* custom scrollbar styles TODO: edit colors with opacity, when provided */\n  scrollbar-face-color: #ddd;\n  scrollbar-highlight-color: #ddd;\n  scrollbar-shadow-color: #ddd;\n  scrollbar-track-color: #f2f2f2;\n  -webkit-overflow-scrolling: touch; }\n\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n  background-color: #f2f2f2; }\n\n::-webkit-scrollbar-thumb {\n  background-color: #ddd;\n  border-radius: 10px; }\n\n::-webkit-scrollbar-thumb:hover {\n  background-color: #c2c2c2; }\n\n::-webkit-scrollbar-corner {\n  background-color: #f2f2f2; }\n\nheader,\nnav,\nsection,\nmain,\narticle,\naside,\nfigure,\ntoolbar,\niframe,\nobject,\nsvg {\n  display: block; }\n\nhtml {\n  height: 100%;\n  background: #fff;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  overflow: hidden; }\n\nbody {\n  height: 100%;\n  color: #363636;\n  background: #f8f8f8;\n  font: 400 14px/18px \"Open Sans\", Arial, Helvetica, sans-serif; }\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  line-height: normal; }\n\ndl,\ndt,\ndd,\nul {\n  list-style: none; }\n\nol {\n  padding: 0 0 0 20px; }\n\nform,\ninput,\ntextarea,\nselect {\n  resize: none; }\n\nform,\ntextarea {\n  width: 100%; }\n\ninput,\ntextarea,\nselect {\n  border-radius: 0; }\n  input:focus,\n  textarea:focus,\n  select:focus {\n    outline: none; }\n  input[type=\"submit\"]:focus,\n  textarea[type=\"submit\"]:focus,\n  select[type=\"submit\"]:focus {\n    border: none !important; }\n\nbutton {\n  outline: none;\n  border-radius: 0; }\n\nimg {\n  max-width: 100%;\n  height: auto;\n  display: block;\n  border: 0; }\n\ntable {\n  border-collapse: collapse; }\n\na {\n  text-decoration: none;\n  color: #000; }\n\nbody {\n  margin: 0;\n  font: 400 14px/22px \"Open Sans\", Arial, Helvetica, sans-serif; }\n\n.ua-margin-bottom-medium {\n  margin-bottom: 20px; }\n\n.ua-margin-top-auto {\n  margin-top: auto; }\n\n.ua-padding-medium,\n.ua-padding-medium.box {\n  padding: 20px; }\n\n.ua-border-top {\n  border-top: 1px solid #ececec; }\n\n.ua-absolute-center-top {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%) translateY(-50%); }\n\n.themes--preview {\n  position: relative;\n  float: left;\n  border-radius: 2px 2px 0 0;\n  overflow: hidden; }\n  .themes--preview:before {\n    content: '';\n    position: absolute;\n    top: 5%;\n    right: 5%;\n    bottom: 5%;\n    left: 5%;\n    background: #000;\n    opacity: 0;\n    transition: all 0.2s ease-out; }\n  .themes--preview .themes--preview-icon {\n    position: absolute;\n    left: 50%;\n    margin-left: -20px;\n    top: 50%;\n    margin-top: -10px;\n    opacity: 0;\n    transition: all 0.2s ease-out; }\n  .themes--preview:hover:before {\n    opacity: 0.4;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0; }\n  .themes--preview:hover .themes--preview-icon {\n    opacity: 1;\n    margin-top: -20px; }\n  .themes--preview.themes--preview-current img {\n    opacity: 0.2; }\n\n.themes--footer .themes--footer-price {\n  font-size: 14px;\n  color: #858484;\n  margin-left: 5px; }\n", ""]);

// exports
exports.locals = {
	"color-groups": "base | colors | primary | semantic | chart",
	"colors-white": "#fff",
	"colors-red": "#f54545",
	"colors-green": "#6acb4c",
	"colors-body-color": "#363636",
	"colors-grey-90": "#444",
	"colors-grey-80": "#666",
	"colors-grey-70": "#858484",
	"colors-grey-60": "#a4a4a4",
	"colors-grey-50": "#c2c2c2",
	"colors-grey-40": "#ddd",
	"colors-grey-30": "#ececec",
	"colors-grey-20": "#f2f2f2",
	"colors-grey-10": "#f8f8f8",
	"colors-black": "#000",
	"base-brown-100": "#343230",
	"base-brown-80": "#474340",
	"base-brown-60": "#61554c",
	"base-brown-40": "#998673",
	"base-brown-20": "#c1aa95",
	"base-earth-100": "#bbb6af",
	"base-earth-80": "#c7c1b8",
	"base-earth-60": "#d7cebf",
	"base-earth-40": "#eae4db",
	"base-earth-20": "#e9e7db",
	"base-earth-10": "#f7f5eb",
	"primary-romantic-purple-base": "#834ba2",
	"primary-romantic-purple-dark": "#5a3770",
	"primary-romantic-purple-light": "#ab83c4",
	"primary-sky-blue-base": "#25b8d2",
	"primary-sky-blue-dark": "#1797ae",
	"primary-sky-blue-light": "#57d0dd",
	"primary-mint-base": "#3fc798",
	"primary-mint-dark": "#2cab7f",
	"primary-mint-light": "#79dbb5",
	"primary-grassy-base": "#96cb4c",
	"primary-grassy-dark": "#81a03c",
	"primary-grassy-light": "#b7dd7a",
	"primary-desert-sunset-base": "#eca03e",
	"primary-desert-sunset-dark": "#c2802a",
	"primary-desert-sunset-light": "#fbc75c",
	"primary-salmon-base": "#f57b45",
	"primary-salmon-dark": "#d45e2a",
	"primary-salmon-light": "#ef9a78",
	"semantic-color-primary": "#f57b45",
	"semantic-color-primary-hovered": "#d45e2a",
	"semantic-color-primary-active": "#ef9a78",
	"semantic-color-secondary": "#25b8d2",
	"semantic-color-secondary-hovered": "#1797ae",
	"semantic-color-secondary-active": "#57d0dd",
	"semantic-color-light": "#fff",
	"semantic-color-light-hovered": "#fff",
	"semantic-color-light-active": "#fff",
	"semantic-color-dark": "#f8f8f8",
	"semantic-color-dark-hovered": "#f2f2f2",
	"semantic-color-dark-active": "#f8f8f8",
	"semantic-color-error": "#f54545",
	"semantic-color-success": "#6acb4c",
	"semantic-color-warning": "#eca03e",
	"semantic-color-instruction": "#25b8d2",
	"semantic-color-info": "#834ba2",
	"semantic-color-hint": "#c2c2c2",
	"chart-first": "#25b8d2",
	"chart-second": "#f57b45",
	"chart-third": "#96cb4c",
	"chart-fourth": "#eca03e",
	"chart-fifth": "#3fc798",
	"chart-sixth": "#ab83c4",
	"chart-seventh": "#c1aa95",
	"chart-eighth": "#c2c2c2"
};